import { column, edge, flow, makeFlow, node } from "../builders";
import type { TemplateDef } from "../types";

const runway = column("f1", 100, 70, 92, [
  ["t1", "auto-trigger", "Joined the waitlist", { props: { triggerType: "Form Submitted", event: "Waitlist form" } }],
  ["e1", "auto-email", "You're on the list", { props: { subject: "You're in — here's what's coming" } }],
  ["w1", "auto-wait", "Wait 3 days", { props: { duration: "3", unit: "days" } }],
  ["e2", "auto-email", "Behind the scenes", { props: { subject: "How we built it (and who it's for)" } }],
  ["e3", "auto-email", "Doors open Tuesday", { props: { subject: "Tuesday 9am — waitlist gets first look" } }],
]);

const open = column("f2", 100, 70, 92, [
  ["t2", "auto-trigger", "Cart opens", { props: { triggerType: "Scheduled", event: "Launch day 09:00" } }],
  ["e4", "auto-email", "Doors are open", { props: { subject: "It's live — waitlist pricing inside" } }],
  ["w2", "auto-wait", "Wait 2 days", { props: { duration: "2", unit: "days" } }],
  ["e5", "auto-email", "Who it's for (and who it isn't)", { props: { subject: "Honest answers to the 5 questions we keep getting" } }],
  ["s1", "auto-sms", "Closing in 3 hours", { props: { message: "Cart closes at midnight — {{link.checkout}}" } }],
  ["c1", "auto-condition", "Bought?", { props: { condition: "Has tag 'launch-buyer'" } }],
  ["tg", "auto-tag-add", "Tag: launch-nonbuyer", { props: { tag: "launch-nonbuyer" } }],
]);

const def: TemplateDef = {
  slug: "product-launch-runway",
  name: "Product Launch Runway",
  category: "E-commerce",
  tagline:
    "Waitlist, runway, cart open, deadline close — the whole launch on one canvas.",
  description:
    "A free product launch funnel template: a waitlist flow warms the list before launch day, then a cart-open flow runs the offer, the objection email, the closing SMS and a bought? branch that separates buyers from the retargeting list. Clone it into FrazzleCRM and run the launch from one map.",
  whatsInside: [
    "Waitlist page feeding a three-email pre-launch runway",
    "Scheduled cart-open trigger so launch day fires itself",
    "Objection-handling email plus a deadline SMS before close",
    "Buyer branch and a non-buyer tag for the post-launch follow-up",
  ],
  flow: makeFlow(
    [
      node("src1", "traffic-email", "Email list", 40, 60, { props: { list: "Main list" } }),
      node("src2", "traffic-instagram", "Instagram", 40, 220),
      node("wl", "page-optin", "Waitlist", 360, 140, { props: { magnet: "Early access + launch pricing" } }),
      flow("f1", "Pre-Launch Runway", 680, 40, 420, 580),
      ...runway.nodes,
      node("sp", "page-sales", "Launch page", 1180, 140, { props: { price: "$197" } }),
      flow("f2", "Cart Open → Close", 1500, 40, 420, 764),
      ...open.nodes,
      node("co", "page-checkout", "Checkout", 2020, 260, { props: { price: "$197", bump: "Add the workbook — $27" } }),
      node("out", "outcome-sale", "Launch sale", 2340, 260, { props: { value: "$197" } }),
      node("n1", "util-note", "The deadline is the mechanism", 360, 340, {
        notes:
          "Most launch revenue lands in the final hours. If nothing actually closes at midnight, the SMS is a lie and the next launch converts worse — set a real deadline and keep it.",
      }),
    ],
    [
      edge("src1", "wl"),
      edge("src2", "wl"),
      edge("wl", "f1"),
      ...runway.edges,
      edge("f1", "sp"),
      edge("sp", "f2"),
      ...open.edges,
      edge("f2", "co"),
      edge("co", "out"),
    ]
  ),
};

export default def;
